/* this file is transformed by vux-loader */
/* eslint-disable */
import _objectSpread from "G:/SVN/\u5B9A\u5236\u9879\u76EE/\u534E\u7535\u5F00\u5173/7_\u6E90\u4EE3\u7801/front/smy-vux-cli3-h5-huadian/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.string.match.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import FormMobile from '@/components/Base/FormMobile';
import LoadingButton from '@/components/Base/LoadingButton';
import ViewBox from "vux/src/components/view-box/index.vue";
import XInput from "vux/src/components/x-input/index.vue";
import Group from "vux/src/components/group/index.vue";
import XButton from "vux/src/components/x-button/index.vue";
import XProgress from "vux/src/components/x-progress/index.vue";
import Msg from "vux/src/components/msg/index.vue";
import ImgUploadInput from '@/components/ImgUploadInput';
export default {
  name: 'register',
  components: {
    ViewBox: ViewBox,
    FormMobile: FormMobile,
    XInput: XInput,
    Group: Group,
    XButton: XButton,
    LoadingButton: LoadingButton,
    XProgress: XProgress,
    Msg: Msg,
    ImgUploadInput: ImgUploadInput
  },
  data: function data() {
    return {
      isShowLogin: true,
      progress: {
        progress: 0
      },
      interval: null,
      time: 0,
      code: '发送验证码',
      form: {
        name: '',
        phone: '',
        verify_code: '',
        unit: '',
        imgUrl: []
      },
      rules: {
        name: {
          required: true,
          message: '名称必填'
        },
        phone: {
          required: true,
          message: '手机号必填'
        },
        verify_code: {
          required: true,
          message: '验证码必填'
        },
        unit: {
          required: true,
          message: '单位必填'
        },
        imgUrl: {
          required: true,
          message: '照片必填'
        }
      }
    };
  },
  watch: {
    time: function time(v) {
      if (this.time <= 0) {
        this.code = '发送验证码';
        if (this.interval) clearInterval(this.interval);
      } else {
        this.code = "".concat(this.time, "s\u540E\u91CD\u65B0\u53D1\u9001");
      }
    }
  },
  created: function created() {},
  methods: {
    validate: function validate() {
      return this.$refs.form.validate();
    },
    submit: function submit() {
      var _this = this;

      var data = _objectSpread(_objectSpread({}, this.form), {}, {
        phone: this.form.phone.replace(/\s+/g, ''),
        code: this.form.verify_code,
        imgUrl: this.form.imgUrl.map(function (v) {
          return v.file_url;
        })
      });

      return this.$http.post('/front/register', data).then(function (res) {
        if (res.data.code == 0) {
          _this.$vux.toast.text('注册成功');

          setTimeout(function () {
            _this.$router.back();
          }, 1000);
        } else {
          _this.$vux.toast.text(res.data.msg);
        }
      });
    },
    sendCode: function sendCode() {
      var _this2 = this;

      if (!this.form.phone.replace(/\s+/g, '').match(/^(\+?0?86-?)?1[3456789]\d{9}$/)) {
        this.$vux.toast.text('请输入正确的手机号码');
        return;
      }

      this.$http.post('/front/codeContent', {
        phone: this.form.phone.replace(/\s+/g, '')
      }).then(function (res) {
        if (res.data.code == 0) {
          _this2.time = 60;
          _this2.interval = setInterval(function () {
            _this2.time--;
          }, 1000);

          _this2.$vux.toast.text('发送成功');
        } else {
          _this2.$vux.toast.text('发送失败');
        }
      });
    }
  }
};